import { Countries } from 'shared/enums';
import { create } from 'zustand';

export interface Budget {
  totalOffline: number | null;
  // otherCosts: number | null;
  techCosts: number | null;
  totalBudget: number | null;
}

export interface OfflineStoreTotalBudget {
  [Countries.POLAND]: Budget;
  [Countries.LITHUANIA]: Budget;
  [Countries.LATVIA]: Budget;
  [Countries.ESTONIA]: Budget;
  resetTotalBudget: (key: Countries) => void;
  updateOfflineBudget: (key: Countries, newBudget: Budget) => void;
}

const INITIAL_BUDGET = {
  totalOffline: 0,
  otherCosts: 0,
  techCosts: 0,
  totalBudget: 0,
};

export const useTotalOfflineBudgetStore = create<OfflineStoreTotalBudget>(
  (set) => ({
    [Countries.POLAND]: INITIAL_BUDGET,
    [Countries.LITHUANIA]: INITIAL_BUDGET,
    [Countries.LATVIA]: INITIAL_BUDGET,
    [Countries.ESTONIA]: INITIAL_BUDGET,
    resetTotalBudget: (country: Countries) =>
      set((state) => ({
        ...state,
        [country]: {
          totalOffline: 0,
          otherCosts: 0,
          techCosts: 0,
          totalBudget: 0,
        },
      })),
    updateOfflineBudget: (country: Countries, newBudget: Budget) =>
      set((state) => ({
        ...state,
        [country]: { ...state[country], ...newBudget },
      })),
  })
);
